import { render, staticRenderFns } from "./PersonComponentModal.vue?vue&type=template&id=2018c2ee&scoped=true"
import script from "./PersonComponentModal.vue?vue&type=script&lang=js"
export * from "./PersonComponentModal.vue?vue&type=script&lang=js"
import style0 from "./PersonComponentModal.vue?vue&type=style&index=0&id=2018c2ee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2018c2ee",
  null
  
)

export default component.exports